// base styles
import borders from "assets/mavric-theme/base/borders";
import typography from "assets/mavric-theme/base/typography";
import colors from "assets/mavric-theme/base/colors";

// helper functions
import pxToRem from "assets/mavric-theme/functions/pxToRem";
import Primary from "components/Typography/Primary";

const { borderRadius } = borders;
const { size } = typography;
const { primary} = colors;

const tableHead = {
  styleOverrides: {
    root: {
      display: "contents",
      //padding: `${pxToRem(2)} ${pxToRem(2)}`,
      padding: `${pxToRem(16)} ${pxToRem(16)} 0 ${pxToRem(16)}`,
      borderRadius: `${borderRadius.xl} ${borderRadius.xl} 0 0`,
      fontSize: size.xs,
      color: primary.focus,
    },
  },
};

export default tableHead;
